import * as Yup from 'yup';
import { nameSchema } from './fieldSchemas';

export const Step1HospitalSchema = Yup.object().shape({
  hospitalName: nameSchema({
    required: true,
    requiredMessage: 'Hastane adı zorunludur',
  }).min(2, 'Hastane adı en az 2 karakter olmalıdır'),
  hospitalLocation: Yup.string().required('Hastane lokasyonu zorunludur'),
});

export const Step2TagSchema = Yup.object().shape({
  prefix: Yup.string().required('Ön ek zorunludur').min(1, 'Ön ek en az 1 karakter olmalıdır'),
});

export const Step1HospitalTagSelectSchema = Yup.object().shape({
  hospitalId: Yup.number()
    .required('Hastane seçimi zorunludur')
    .nullable()
    .test('not-null', 'Hastane seçimi zorunludur', value => value !== null),
  tagId: Yup.number()
    .required('Etiket ön eki seçimi zorunludur')
    .nullable()
    .test('not-null', 'Etiket ön eki seçimi zorunludur', value => value !== null),
});
